import { cn } from '@/lib/utils';

interface ContentRevisionBadgeProps {
  revision: number;
  onClick: () => void;
  className?: string;
}

export function ContentRevisionBadge({ revision, onClick, className }: ContentRevisionBadgeProps) {
  if (revision <= 1) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      title="Revisions"
      aria-label={`Revisions: ${revision}`}
      data-testid="content-revision-badge"
      className={cn(
        'text-sm text-muted-foreground hover:text-foreground transition-colors px-1.5 py-0.5 rounded',
        className
      )}
    >
      Revisions {revision}
    </button>
  );
}
